import * as R from 'ramda';

export const stop = e => e.stopPropagation();
export const prevent = e => e.preventDefault();

export const handleWith = (...handlers) => (...args) => R.forEach(
  handler => handler(...args),
  handlers
);
